import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let hasConfiguredGoogleMaps = false;
let placesLibraryPromise;

export const loadGooglePlacesLibrary = () => {
  if (!GOOGLE_MAPS_API_KEY) {
    return Promise.reject(
      new Error('Google Maps API key is missing. Set REACT_APP_GOOGLE_MAPS_API_KEY.')
    );
  }

  if (!hasConfiguredGoogleMaps) {
    setOptions({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      language: 'en',
      region: 'IN',
    });
    hasConfiguredGoogleMaps = true;
  }

  if (!placesLibraryPromise) {
    placesLibraryPromise = importLibrary('places');
  }

  return placesLibraryPromise;
};
